import { render } from "./MasterData.vue?vue&type=template&id=1adab52e"
import script from "./MasterData.vue?vue&type=script&lang=js"
export * from "./MasterData.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__